import { PaymentsTable } from '~widgets/payments-table';

export const PaymentsPage = () => <PaymentsTable />;
